import { createApi } from '@reduxjs/toolkit/query/react';

import { makeBaseQueryWithReauth } from './endpoints/baseQueryWithReauth';
import { getCalendarUrl } from './host-urls';

/**
 * RTK Query instance for the external commodity-calendar host (one instance per
 * backend host, ADR-0015). Endpoints are hand-written and injected via
 * `injectEndpoints`.
 *
 * Sends the OIDC Bearer like the internal hosts because the legacy axios stack
 * always has — whether this host actually validates it is unverified; behavior
 * preserved pending a cleanup spike.
 */
export const calendarApi = createApi({
  reducerPath: 'calendarApi',
  baseQuery: makeBaseQueryWithReauth(getCalendarUrl),
  endpoints: () => ({})
});
